// HeroSection.js

import React, { useEffect, useState } from "react";
import "./HeroSection.css";

const HeroSection = () => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setTimeout(() => setAnimate(true), 200); // delay for smooth entrance
  }, []);

  const scrollToJournals = () => {
    const journalsSection = document.getElementById("journals-section");
    if (journalsSection) {
      journalsSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className={`hero-section ${animate ? "fade-in" : ""}`}>
      <h1 className="hero-title">
        WhisperWall <span className="heart">💜</span>
      </h1>
      <p className="hero-tagline">
        “Your thoughts matter. Your feelings deserve space. Let them breathe here.”
      </p>
      <button className="explore-btn" onClick={scrollToJournals}>
        Explore Journals
      </button>
    </section>
  );
};

export default HeroSection;
